/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.academics.sequence'},
});

const SequenceItem = () => (
  <RouteLinkItem
    route="midas/settings/academics/sequence"
    title={messages.title}
  />
);

export default SequenceItem;
